import { Facebook, Instagram, Linkedin } from "lucide-react";
import { LOGO, NAV_LINKS, PHONE, PHONE_HREF, EMAIL, EMAIL_HREF } from "../lib/site";

export const Footer = () => {
  return (
    <footer className="bg-[#171717] text-ivory pt-16 pb-8 border-t border-gold/15" data-testid="footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid md:grid-cols-3 gap-10 pb-12">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO} alt="MB Notary Services" className="h-12 w-12 rounded-full ring-1 ring-gold/40 object-cover" />
              <div>
                <div className="font-serif text-gold text-lg">MB Notary Services</div>
                <div className="eyebrow text-taupe text-[9px]">Miranda Baggett · LLC</div>
              </div>
            </div>
            <p className="font-serif italic text-taupe">Professional. Reliable. Convenient.</p>
          </div>

          <div>
            <p className="eyebrow text-gold mb-5">Navigate</p>
            <ul className="space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-ivory/70 hover:text-gold text-sm font-light transition-colors" data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}>{l.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="eyebrow text-gold mb-5">Get In Touch</p>
            <a href={PHONE_HREF} className="block text-ivory/70 hover:text-gold text-sm font-light mb-3 transition-colors">{PHONE}</a>
            <a href={EMAIL_HREF} className="block text-ivory/70 hover:text-gold text-sm font-light mb-5 transition-colors">{EMAIL}</a>
            <div className="flex gap-3">
              {[Instagram, Facebook, Linkedin].map((Icon, i) => (
                <a key={i} href="#home" className="h-10 w-10 rounded-full border border-gold/30 grid place-items-center hover:bg-gold/10 hover:border-gold transition-all" data-testid={`social-${i}`} aria-label="Social link">
                  <Icon size={16} strokeWidth={1.5} className="text-gold" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="hairline pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-ivory/40 text-xs tracking-wide">Copyright © 2026 MB Notary Services LLC. All rights reserved.</p>
          <p className="font-serif italic gold-text text-sm">Making your important moments official.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
